var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 33,
    rx: 7,
    stroke: "#BABABA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1202 21.6809C26.3065 20.2812 25.8743 18.2722 25.8743 15.875C25.8743 13.7864 25.0446 11.7834 23.5678 10.3065C22.0909 8.82969 20.0879 8 17.9993 8C15.9107 8 13.9077 8.82969 12.4308 10.3065C10.954 11.7834 10.1243 13.7864 10.1243 15.875C10.1243 18.2731 9.69398 20.2812 8.88023 21.6809C8.71418 21.9664 8.62616 22.2906 8.62501 22.6208C8.62386 22.9511 8.70962 23.2759 8.87367 23.5625C9.03668 23.8493 9.27329 24.0874 9.55906 24.2522C9.84484 24.417 10.1694 24.5025 10.4993 24.5H13.8912C13.9842 25.5253 14.4572 26.4787 15.2174 27.173C15.9775 27.8673 16.9698 28.2523 17.9993 28.2523C19.0288 28.2523 20.0211 27.8673 20.7812 27.173C21.5413 26.4787 22.0144 25.5253 22.1074 24.5H25.4993C25.8287 24.502 26.1527 24.4163 26.4379 24.2515C26.7232 24.0867 26.9593 23.8489 27.1221 23.5625C27.2869 23.2763 27.3734 22.9517 27.3731 22.6215C27.3728 22.2912 27.2856 21.9668 27.1202 21.6809ZM17.9993 26C17.567 26.0001 17.148 25.8508 16.8132 25.5775C16.4784 25.3041 16.2482 24.9235 16.1618 24.5H19.8368C19.7503 24.9235 19.5202 25.3041 19.1854 25.5775C18.8505 25.8508 18.4315 26.0001 17.9993 26ZM11.1237 22.25C11.9534 20.5625 12.3743 18.4194 12.3743 15.875C12.3743 14.3832 12.9669 12.9524 14.0218 11.8975C15.0767 10.8426 16.5075 10.25 17.9993 10.25C19.4911 10.25 20.9219 10.8426 21.9768 11.8975C23.0317 12.9524 23.6243 14.3832 23.6243 15.875C23.6243 18.4184 24.0443 20.5625 24.874 22.25H11.1237Z",
    fill: "#04245C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 10,
    height: 4,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.25C16.2833 27.25 15.2379 26.5747 14.6105 25.8445C14.2877 25.4689 14.0752 25.0791 13.9421 24.75H22.0579C21.9248 25.0791 21.7123 25.4689 21.3895 25.8445C20.7621 26.5747 19.7167 27.25 18 27.25Z",
    stroke: "#2173FF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon_notification.b7baef78bba3fd9c9c341a960442320c.svg";
export { ForwardRef as ReactComponent };